import { PersistGate as PersistGateComponent } from 'redux-persist/integration/react';

export default PersistGateComponent;
